<template>
  <el-dropdown style="padding:0px" @command="handleCommand">
    <span class="el-dropdown-link">
      <!-- 下拉菜单 -->
      状态<i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="">全部</el-dropdown-item>
      <el-dropdown-item command="待付款">待付款</el-dropdown-item>
      <el-dropdown-item command="已付款">已付款</el-dropdown-item>
      <el-dropdown-item command="已退款">已退款</el-dropdown-item>
      <el-dropdown-item command="已取消">已取消</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
 
<script>
export default {
  data () {
    return {
      value: ""
    };
  },
  props: {
    options: {
      type: Array,
      default: function () {
        return [
          { label: "全部", value: "全部" },
          { label: "题库", value: "题库" },
          { label: "套餐", value: "套餐" }
        ];
      }
    }
  },
  watch: {
    defaultValue (newVal, oldVal) {
      let self = this;
      self.value = newVal;
    }
  },
  methods: {
    handleCommand (command) {
      this.$emit("selectChange", command);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/orderInfo/SelectHeader.vue